import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import CKEditor from 'ckeditor4-react';

let config = {    
	height : '230px',
    width :'65%',
	addCss: '.divImagenConBajada img{width: 100% !important;}',
	toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		'/',
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
	removeButtons : 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent',
	stylesSet : [
		{ name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
		{ name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
		{ name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
		{ name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
	],
	div_wrapTable : true,
	extraAllowedContent: 'section class iframe style video embed',
	allowedContent : true,
	image: {toolbar: [ 'imageTextAlternative' ]},
	extraPlugins : 'embed, iframe',
	embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
	skin : 'kama'
}

export default class AdmModuloServicioExportador extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            descripcionLongitud:0,
            atencionLongitud:0,
            contactoLongitud:0,
            atencionVirtualLongitud:0,
            queremosTituloLongitud:0,
            queremosContenidoLongitud:0,   
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                msex_Descripcion:"",
                msex_Atencion:"",
                msex_Contacto:"",
                msex_AtencionVirtual:"",
                msex_QueremosTitulo:"",
                msex_QueremosContenido:"",
                msex_QueremosEnlace:"",
                msex_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                msex_Id:0,
                msex_Descripcion:"",
                msex_Atencion:"",
                msex_Contacto:"",
                msex_AtencionVirtual:"",
                msex_QueremosTitulo:"",
                msex_QueremosContenido:"",
                msex_QueremosEnlace:"",
                msex_Activo:true
            },
            Validacion: {
                msex_Descripcion: {
                    Error: false,                    
                },
                msex_Atencion: {
                    Error: false,                    
                },
                msex_Contacto: {
                    Error: false,                    
                },
                msex_AtencionVirtual: {
                    Error: false,                    
                },
                msex_QueremosTitulo: {
                    Error: false,                    
                },
                msex_QueremosContenido: {
                    Error: false,                    
                },
                msex_QueremosEnlace: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                msex_Descripcion: {
                    Error: false,                    
                },
                msex_Atencion: {
                    Error: false,                    
                },
                msex_Contacto: {
                    Error: false,                    
                },
                msex_AtencionVirtual: {
                    Error: false,                    
                },
                msex_QueremosTitulo: {
                    Error: false,                    
                },
                msex_QueremosContenido: {
                    Error: false,                    
                },
                msex_QueremosEnlace: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let descripcionLongitud = this.state.descripcionLongitud;
        let atencionLongitud = this.state.atencionLongitud;
        let contactoLongitud = this.state.contactoLongitud;
        let atencionVirtualLongitud = this.state.atencionVirtualLongitud;
        let queremosTituloLongitud = this.state.queremosTituloLongitud;
        let queremosContenidoLongitud = this.state.queremosContenidoLongitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'msex_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'msex_Atencion'){
            atencionLongitud = value.length;
        }
        if(target.name == 'msex_Contacto'){
            contactoLongitud = value.length;
        }
        if(target.name == 'msex_AtencionVirtual'){
            atencionVirtualLongitud = value.length;
        }
        if(target.name == 'msex_QueremosTitulo'){
            queremosTituloLongitud = value.length;
        }
        if(target.name == 'msex_QueremosContenido'){
            queremosContenidoLongitud = value.length;
        }

        this.setState({
            resource: copyResource,
            descripcionLongitud: descripcionLongitud,
            atencionLongitud: atencionLongitud,
            contactoLongitud:contactoLongitud,
            atencionVirtualLongitud: atencionVirtualLongitud,
            queremosTituloLongitud: queremosTituloLongitud,
            queremosContenidoLongitud: queremosContenidoLongitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let descripcionLongitud = this.state.descripcionLongitud;
        let atencionLongitud = this.state.atencionLongitud;
        let contactoLongitud = this.state.contactoLongitud;
        let atencionVirtualLongitud = this.state.atencionVirtualLongitud;
        let queremosTituloLongitud = this.state.queremosTituloLongitud;
        let queremosContenidoLongitud = this.state.queremosContenidoLongitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'msex_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'msex_Atencion'){
            atencionLongitud = value.length;
        }
        if(target.name == 'msex_Contacto'){
            contactoLongitud = value.length;
        }
        if(target.name == 'msex_AtencionVirtual'){
            atencionVirtualLongitud = value.length;
        }
        if(target.name == 'msex_QueremosTitulo'){
            queremosTituloLongitud = value.length;
        }
        if(target.name == 'msex_QueremosContenido'){
            queremosContenidoLongitud = value.length;
        }

        this.setState({
            resourceEdit: copyResource,
            descripcionLongitud: descripcionLongitud,
            atencionLongitud: atencionLongitud,
            contactoLongitud:contactoLongitud,
            atencionVirtualLongitud: atencionVirtualLongitud,
            queremosTituloLongitud: queremosTituloLongitud,
            queremosContenidoLongitud: queremosContenidoLongitud,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.msex_Descripcion == '') {              
            newState.Validacion.msex_Descripcion = {Error: true};
            newState.hasError = true;
        }
        /*
        if (newState.resource.msex_Atencion == '') {  
            newState.Validacion.msex_Atencion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.msex_Contacto == '') {              
            newState.Validacion.msex_Contacto = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.msex_AtencionVirtual == '') {  
            newState.Validacion.msex_AtencionVirtual = {Error: true};
            newState.hasError = true;
        }
        */
        if (newState.resource.msex_QueremosTitulo == '') {  
            newState.Validacion.msex_QueremosTitulo = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.msex_QueremosContenido == '') {              
            newState.Validacion.msex_QueremosContenido = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.msex_QueremosEnlace == '') {  
            newState.Validacion.msex_QueremosEnlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloServicioExportadorUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'msex_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),{ 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {             
            
            if (data.data.isSucess){
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.msex_Descripcion = '';
                stateResponse.resource.msex_Atencion = '';
                stateResponse.resource.msex_Contacto = '';
                stateResponse.resource.msex_AtencionVirtual = '';
                stateResponse.resource.msex_QueremosTitulo = '';
                stateResponse.resource.msex_QueremosContenido = '';
                stateResponse.resource.msex_QueremosEnlace = '';

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.msex_Descripcion == '') {              
            newState.ValidacionEdit.msex_Descripcion = {Error: true};
            newState.hasError = true;
        }

        /*
        if (newState.resourceEdit.msex_Atencion == '') {  
            newState.ValidacionEdit.msex_Atencion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.msex_Contacto == '') {              
            newState.ValidacionEdit.msex_Contacto = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.msex_AtencionVirtual == '') {  
            newState.ValidacionEdit.msex_AtencionVirtual = {Error: true};
            newState.hasError = true;
        }
        */

        if (newState.resourceEdit.msex_QueremosTitulo == '') {  
            newState.ValidacionEdit.msex_QueremosTitulo = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.msex_QueremosContenido == '') {              
            newState.ValidacionEdit.msex_QueremosContenido = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.msex_QueremosEnlace == '') {  
            newState.ValidacionEdit.msex_QueremosEnlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloServicioExportadorUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'msex_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.msex_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }
 

    loadModulo = (pmod_Id) =>  {
        const url = `${API_URL}ModuloServicioExportadorUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ 
                resourceEdit: data.result, 
                response: data, 
                error: data.Error 
            });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps) {
        let mweb = 17;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
    } 

    onEditorChangeEdit( evt ) {
        //let stateResource = this.state.resourceEdit;
        //stateResource.mcon_Contenido = evt.editor.getData();
        /*
        this.setState( {
            resourceEdit: stateResource
        });
        */
    }

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">
                        {this.state.resourceEdit.msex_Id > 0 ?
                            <React.Fragment>
                                {/*EDIT*/}
                                <div className="containerFormCreation divModuloPopup_Panel">
                                    {this.state.added ?
                                        <div className="txtFile x-1">
                                            <strong style={{
                                                display: "block",
                                                textAlign:"center",
                                                color: "#008000a3"
                                            }}> Registro actualizado satisfactoriamente!!</strong>
                                        </div> : null
                                    }
                                    
                                    
                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Descripción" 
                                            value={this.state.resourceEdit.msex_Descripcion} 
                                            name="msex_Descripcion"  
                                            className={this.state.ValidacionEdit.msex_Descripcion.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={100} />
                                            <span data-length={100}>{this.state.descripcionLongitud}/100</span>
                                        </div>

                                    {/* 

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Atención" 
                                            value={this.state.resourceEdit.msex_Atencion} 
                                            name="msex_Atencion"  
                                            className={this.state.ValidacionEdit.msex_Atencion.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={110} />
                                            <span data-length={110}>{this.state.atencionLongitud}/110</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Contacto" 
                                            value={this.state.resourceEdit.msex_Contacto} 
                                            name="msex_Contacto"  
                                            className={this.state.ValidacionEdit.msex_Contacto.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={110} />
                                            <span data-length={110}>{this.state.contactoLongitud}/110</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Atención Virtual" 
                                            value={this.state.resourceEdit.msex_AtencionVirtual} 
                                            name="msex_AtencionVirtual"  
                                            className={this.state.ValidacionEdit.msex_AtencionVirtual.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={40} />
                                            <span data-length={40}>{this.state.atencionVirtualLongitud}/40</span>
                                        </div>
                                    */}

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Título Queremos" 
                                            value={this.state.resourceEdit.msex_QueremosTitulo} 
                                            name="msex_QueremosTitulo"  
                                            className={this.state.ValidacionEdit.msex_QueremosTitulo.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={30} />
                                            <span data-length={30}>{this.state.queremosTituloLongitud}/30</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Contenido Queremos" 
                                            value={this.state.resourceEdit.msex_QueremosContenido} 
                                            name="msex_QueremosContenido"  
                                            className={this.state.ValidacionEdit.msex_QueremosContenido.Error ? "error" : ""}
                                            onChange={this.handleInputChangeEdit} 
                                            style={{height:"100px"}}
                                            maxLength={160} />
                                            <span data-length={160}>{this.state.queremosContenidoLongitud}/160</span>
                                        </div>

                                        <div className="txtFile x-1">
                                            <input type="text" placeholder="Enlace Queremos" 
                                            name='msex_QueremosEnlace' 
                                            value={this.state.resourceEdit.msex_QueremosEnlace} 
                                            className={this.state.ValidacionEdit.msex_QueremosEnlace.Error ? "error" : ""} 
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>
                                    
                                    {/* 
                                    <CKEditor
                                        //data={this.state.resource.mcon_Contenido}
                                        onChange={this.onEditorChangeEdit} 
                                        config={config}
                                    />
                                    */}

                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                                onChange={this.handleInputChangeEdit}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChangeEdit} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChangeEdit} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {/*CREATION*/}
                                <div className="containerFormCreation divModuloPopup_Panel">
                                     
                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Descripción" 
                                            value={this.state.resource.msex_Descripcion} 
                                            name="msex_Descripcion"  
                                            className={this.state.Validacion.msex_Descripcion.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={100} />
                                            <span data-length={100}>{this.state.descripcionLongitud}/100</span>
                                        </div>

                                    {/*
                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Atención" 
                                            value={this.state.resource.msex_Atencion} 
                                            name="msex_Atencion"  
                                            className={this.state.Validacion.msex_Atencion.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={110} />
                                            <span data-length={110}>{this.state.atencionLongitud}/110</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Contacto" 
                                            value={this.state.resource.msex_Contacto} 
                                            name="msex_Contacto"  
                                            className={this.state.Validacion.msex_Contacto.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={110} />
                                            <span data-length={110}>{this.state.contactoLongitud}/110</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Atención Virtual" 
                                            value={this.state.resource.msex_AtencionVirtual} 
                                            name="msex_AtencionVirtual"  
                                            className={this.state.Validacion.msex_AtencionVirtual.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={40} />
                                            <span data-length={40}>{this.state.atencionVirtualLongitud}/40</span>
                                        </div>
                                    */}
                                    
                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Título Queremos" 
                                            value={this.state.resource.msex_QueremosTitulo} 
                                            name="msex_QueremosTitulo"  
                                            className={this.state.Validacion.msex_QueremosTitulo.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={30} />
                                            <span data-length={30}>{this.state.queremosTituloLongitud}/30</span>
                                        </div>

                                        <div className="textareaResumen x-1">
                                            <textarea placeholder="Contenido Queremos" 
                                            value={this.state.resource.msex_QueremosContenido} 
                                            name="msex_QueremosContenido"  
                                            className={this.state.Validacion.msex_QueremosContenido.Error ? "error" : ""}
                                            onChange={this.handleInputChange} 
                                            style={{height:"100px"}}
                                            maxLength={160} />
                                            <span data-length={160}>{this.state.queremosContenidoLongitud}/160</span>
                                        </div>
                                    
                                        <div className="txtFile x-1">
                                            <input type="text" placeholder="Enlace Queremos" 
                                            name='msex_QueremosEnlace' 
                                            value={this.state.resource.msex_QueremosEnlace} 
                                            className={this.state.Validacion.msex_QueremosEnlace.Error ? "error" : ""} 
                                            onChange={this.handleInputChange}/>
                                        </div>
                                    
                                    
                                    {/* 
                                        <CKEditor
                                            //data={this.state.resource.mcon_Contenido}
                                            onChange={this.onEditorChangeEdit} 
                                            config={config}
                                        />
                                    */}

                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
            </div>
        )
    }
}
